import { NgModule } from '@angular/core';
import { MatSidenavModule } from "@angular/material/sidenav";
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SharedModule } from '../shared/shared.module';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { AccountComponent } from './components/account/account.component';

@NgModule({
  declarations: [
    SidebarComponent,
    ToolbarComponent,
    AccountComponent
  ],
  imports: [
    SharedModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule
  ],
  exports: [
    SidebarComponent,
    ToolbarComponent
  ]
})
export class NavigationModule { }
